import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { BASE_API_URL } from "../../utils/constants";

const baseURL = BASE_API_URL;

// Async thunk to fetch bundle skills users
export const fetchUsers = createAsyncThunk(
  "bundleSkills/fetchUsers",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${baseURL}/bundleSkills/user-maintenance`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch bundle skills users"
      );
    }
  }
);

export const fetchCourses = createAsyncThunk(
  "bundleSkills/fetchCourses",
   async (_, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${baseURL}/bundleSkills/courses`, {
        headers: {
          Authorization: localStorage.getItem("token"),
          "Content-Type": "application/json",
        },
      });
      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch bundle skills courses"
      );
    }
  }
)

const bundleSkillsSlice = createSlice({
  name: "bundleSkills",
  initialState: {
    error: false,
    loading: false,
    userMaintenance: [],
    courseData:[],
  },
  reducers: {
    clearError(state) {
      state.error = false;
    },
  },
  extraReducers: (builder) => {
    builder
      // fetchUsers cases
      .addCase(fetchUsers.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(fetchUsers.fulfilled, (state, action) => {
        state.loading = false;
        state.userMaintenance = action.payload;
      })
      .addCase(fetchUsers.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      })      
      // fetchCourses cases
      .addCase(fetchCourses.pending, (state) => {
        state.loading = true;
        state.error = false;
      })
      .addCase(fetchCourses.fulfilled, (state, action) => {
        state.loading = false;
        state.courseData = action.payload;
      })
      .addCase(fetchCourses.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload || "Something went wrong";
      });
  },
});

export const { clearError } = bundleSkillsSlice.actions;
export default bundleSkillsSlice.reducer;
